/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_ExitInputs */

const en_mobile_exit = /** @type {(inputs: Mobile_ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit`)
};

const es_mobile_exit = /** @type {(inputs: Mobile_ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salir`)
};

/**
* | output |
* | --- |
* | "Exit" |
*
* @param {Mobile_ExitInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_exit = /** @type {((inputs?: Mobile_ExitInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_ExitInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_exit(inputs)
	return en_mobile_exit(inputs)
});